<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">启迪智慧，点亮未来</p>

        <div style="width: 87%;margin: 0 auto;margin-top: 3vh;">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 3月主题课程推荐：</p>
            <ul>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=36897&companyId=704" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">包容残疾关系到所有人（字幕） </li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=36770&companyId=704" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">包容性发展及创新促进包容性发展(IID)介绍（字幕） </li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=35507&companyId=704" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">(9/25)Nothing About Us Without Us</li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=49708&companyId=722" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">02.人权管理与规范</li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=39717&companyId=115" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">跨文化组织协调</li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=50078&companyId=529" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">Mental health NEO training</li></a>
            </ul>
        </div>
        <div style="width: 87%;margin: 0 auto;margin-top: 3vh;" v-if="coc">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">必修课程完成情况：</p>
            <ul v-for="(item,index) in coc" :key="index" ref="">
                <a :href="item.link" style="text-decoration: none;color: #000;">
                    <li style="padding: 0;margin-top: 0;">{{ item.Name }}&nbsp;
                        <span v-if="item.iscompleted" style="color: green;font-weight: 800;">已完成</span>
                        <span v-else style="color: red;font-weight: 800;">未完成</span>
                    </li>
                </a>
            </ul>
        </div>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    components: {},
    data() {
        return {
            coc:''
            // themeLink:'',
            // commentRecommendLink:''
        }
    }, 
    created(){
        this.coc=JSON.parse(this.ReportData.coc)
        // this.themeLink=JSON.parse(this.ReportData.themeLink)
        // this.commentRecommendLink=JSON.parse(this.ReportData.commentRecommendLink)
        // console.log(this.themeLink,'主题课程')
    },
    computed:{},
    mounted(){
        
    }
}
</script>

<style scoped>
.body {
    background: 
                url("../../assets/logo2.png") right  top  no-repeat,
                url("../../assets/25February/icon.png") 49% calc(100% + 40px) no-repeat,
                url("../../assets/25February/bg.jpg")  no-repeat;
    background-size: 110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 92%;
    margin: 0 auto;
    padding-left: 8%;
    /* text-align: center; */
    font-size: 20px;
    color: #46429e;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>